import {PropertyID} from 'module/Properties/enum/PropID';
import {createAction} from 'util/redux'

export const noopAction = createAction('noop', (...args: any[]) => ({payload: args}))
export const appInitAction = createAction<{ properties: PropertyID[] }>('appInit')